<style lang="scss" scoped>
.connect {
	&__header {
		&__steps {
			margin-top: 20px;
		}
	}
	&__row {
		@include grid();
	}
	&__left {
		@include grid-col(4);
		padding-right: 40px;
	}
	&__right {
		@include grid-col(8);
		& ::v-deep .box-card {
			margin-bottom: 30px;
		}
	}
	&__pad-bottom {
		margin-bottom: 30px;
	}
}
</style>

<template lang="pug">
.connect
	app-header
		.connect__header(slot='header')
			h1 Reconnect to {{ providerFullName }}
	.container
		.main-panel
			loading(v-if='$apollo.loading')
			.main-panel__padding(v-else='')
				p.mb-0
					| To enable new features, please reconnect your {{ providerName }} account.
				p.mb-0
					| Please use the button below to login as a {{ providerName }} Super Admin user from your {{ providerFullName }} tenant. If you wish to connect a different {{ providerFullName }} tenant, please contact support first. 
			.main-panel__padding.connect__section(v-if="providerCode === 'msad'")
				.connect__row
					.connect__left
						h2 Connection Settings
					.connect__right
						el-card.box-card
							.clearfix(slot='header')
								span Host
							el-form(label-position='top')
								el-form-item(label='Active Directory Domain Controller host and port')
									el-input(v-model='form.msad_host')
						el-card.box-card
							.clearfix(slot='header')
								span Credentials
							el-form(label-position='top')
								el-form-item(label='Username')
									el-input(v-model='form.msad_username')
							el-form(label-position='top')
								el-form-item(label='Password')
									el-input(v-model='form.msad_password' type="password")
				el-button(type='primary', :loading='loading', @click='save').actions {{ loading ? "Saving settings..." : "Save" }}

			.main-panel__footer.text-right(v-else="")
				el-button.mega-action(@click='redirect', type='success') Login to {{ providerName }}
</template>

<script>
import gql from "graphql-tag";
export default {
	data() {
		return {
			auth: null,
			loading: false,
			form: {}
		};
	},

	apollo: {
		auth: {
			query: gql`
				{
					Auth {
						redirect_url
					}
				}
			`,
			update: r => r.Auth
		},
		settings: {
			query: gql`
				{
					Settings {
						has_completed_wizard
						connected
					}
				}
			`,
			update: r => r.Settings
		},
		form: {
			query: gql`
				{
					AdSettings {
						id
						msad_host
						msad_username
						msad_password
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r => {
				const data = _.cloneDeep(r.AdSettings);
				data.msad_password = null;

				return data;
			}
		}
	},

	methods: {
		redirect() {
			window.location.replace(this.auth.redirect_url);
		},

		save() {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: gql`
						mutation SaveAdSettings($object: InputAdSettings!) {
							SaveAdSettings(object: $object) {
								msad_host
								msad_username
								msad_password
							}
						}
					`,
					variables: {
						object: _.pick(this.form, ["msad_host", "msad_username", "msad_password"])
					}
				})
				.then(r => {
					this.loading = false;
					this.$message.success("Active Directory connected");
					this.$router.push({ name: !this.settings.has_completed_wizard ? "wizard.settings" : "directory" });
				})
				.catch(e => {
					this.loading = false;
					this.$message.error("Failed to connect - ensure the host and credentials are correct");
				});
		}
	}
};
</script>
